import React, { createContext, useEffect, useRef, useState } from "react";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import useAlert from "~/common/hooks/useAlert";
import { useTranslation } from "react-i18next";
import { dateToString } from "~/utils/formatter";

export const AppManContext = createContext();

const RoundManContext = ({ children }) => {
	const { t } = useTranslation();

	const roundListRequest = useRequest("post", "/vc/round/search");
	const roundSettingListRequest = useRequest("get", "/vc/round/setting/list");
	const roundFinalSubmitRequest = useRequest("post", "/vc/round/review/setting");
	const roundAdditionalSubmitRequest = useRequest("post", "/vc/round/add/additional");
	const viewDetailRequest = useRequest("get", "vc/round/detail");

	const [roundList, setRoundList] = useState([]);
	const [currentTab, setCurrentTab] = useState("전체");
	const [pending, setPending] = useState(false);
	const [EvalSetModalStep, setEvalSetModalStep] = useState(0);
	const [evaluateSetupModal, setEvaluateSetupModal] = useState(false);
	const [settingList, setSettingList] = useState();
	const [judgeList, setJudgeList] = useState();
	const [check, setCheck] = useState(false);
	const [notiCheck, setNotiCheck] = useState(false);
	const [modi, setModi] = useState(false);
	const [tidx, setTidx] = useState();
	const [modiData, setModiData] = useState();
	const [fin, setFin] = useState(false);
	const [moodi, setMoodi] = useState("modi");
	const [nameSearch, setNameSearch] = useState();

	const roundJudgesListRequest = useRequest(
		"get",
		`/vc/round/member/list?name=${nameSearch || ""}`
	);

	// const roundJudgesListRequest = useRequest("get", `/vc/round/member/list`);

	// 여기서 process one, two, three, four, five 의 데이터 collect
	const [targetRoundIdx, setTargetRoundIdx] = useState();
	const [resultProcessOne, setResultProcessOne] = useState("nope");
	const [resultProcessTwo, setResultProcessTwo] = useState([]);
	const [resultProcessThree, setResultProcessThree] = useState([]);
	const [resultProcessFour, setResultProcessFour] = useState({ title: "", content: "" });

	const modiNotice = {
		title: modiData?.round?.noticeTitle,
		content: modiData?.round?.noticeContent,
	};

	// 추가 심사
	const [addProSteps, setAddProSteps] = useState(0);
	const [addJudgeModal, setAddJudgeModal] = useState(false);
	const [addEvalTarget, setAddEvalTarget] = useState();
	const [roundData, setRoundData] = useState();

	// 추가 심사 데이터 collect for post
	const [resultFromProOne, setresultFromProOne] = useState([]);
	const [resultFromProTwo, setresultFromProTwo] = useState("nope");
	const [resultFromProThree, setresultFromProThree] = useState([]);
	const [resultFromProFour, setresultFromProFour] = useState([]);
	const [resultFromProFive, setresultFromProFive] = useState({ title: "", content: "" });

	const roundAll = ["오픈대기", "진행중", "지원마감", "심사중", "종료"];
	const [roundState, setRoundState] = useState(roundAll);

	const sixMonthsAgo = new Date();
	sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
	const [formData, setFormData] = useState({
		title: "",
		status: roundState,
		page: 1,
		size: 10,
		startDate: dateToString(new Date(null), "yyyy-MM-dd"),
		endDate: dateToString(new Date(), "yyyy-MM-dd"),
	});
	const ref = useRef();

	const [showFinalAlert, FinalAlert] = useAlert();
	const [totalPage, setTotalPage] = useState(1);

	useEffect(() => {
		switch (roundListRequest.state) {
			case API_STATE.done:
				const roundListData = roundListRequest.response.data;
				setTotalPage(roundListData.pageable.totalPage);
				setRoundList(roundListData.list);
				break;
			case API_STATE.error:
				console.log("roundListRequest error>> ", roundListRequest.error);
				alert(t("pages.round.RoundManage.RoundManContext.alert01"));
				break;
			default:
				break;
		}
	}, [roundListRequest.state, roundListRequest.response, roundListRequest.error]);

	useEffect(() => {
		if (currentTab === "전체") {
			setFormData({ ...formData, status: roundAll, page: 1 });
		} else {
			setFormData({ ...formData, status: [currentTab], page: 1 });
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [evaluateSetupModal]);

	useEffect(() => {
		if (currentTab === "전체") {
			setFormData({ ...formData, status: roundAll, page: 1 });
		} else {
			setFormData({ ...formData, status: [currentTab], page: 1 });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTab]);

	useEffect(() => {
		roundListRequest.call(formData, "body");
	}, [formData]);

	// "" null undefined 0 NaN false -> false, not there -> true
	useEffect(() => {
		if (modiData?.round?.noticeTitle && modiData?.round?.noticeContent) {
			setResultProcessFour(modiNotice);
			setNotiCheck(true);
		} else {
			setResultProcessFour(modiNotice);
			setNotiCheck(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modiData]);

	// resultFromProTwo.startDate.toISOString()
	const finalAdditionSubmit = () => {
		const temp = {
			prevRoundIdx: addEvalTarget,
			external: check,
			step: roundData?.round.step + 2,
			startDate: resultFromProTwo?.startDate,
			endDate: resultFromProTwo?.endDate,
			noticeTitle: notiCheck ? resultFromProFive.title : "",
			noticeContent: notiCheck ? resultFromProFive.content : "",
			reviewSettingIdx: resultFromProTwo.settingData.idx,
			additionalCompanyIdxList: resultFromProOne,
			judgeList: [...resultFromProThree, ...(check ? resultFromProFour : [])],
		};

		roundAdditionalSubmitRequest.call(temp);
	};

	useEffect(() => {
		switch (roundAdditionalSubmitRequest.state) {
			case API_STATE.done:
				setAddJudgeModal(false);
				alert(t("pages.round.RoundManage.RoundManContext.alert02"));
				setFormData({ ...formData, status: roundAll, page: 1 });
				break;
			case API_STATE.error:
				console.log(
					"roundAdditionalSubmitRequest error>> ",
					roundAdditionalSubmitRequest.error
				);
				alert(t("pages.round.RoundManage.RoundManContext.alert01"));
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		roundAdditionalSubmitRequest.state,
		roundAdditionalSubmitRequest.response,
		roundAdditionalSubmitRequest.error,
	]);

	const finalSubmit = () => {
		roundFinalSubmitRequest.call({
			roundIdx: targetRoundIdx,
			external: check,
			noticeTitle: notiCheck ? resultProcessFour.title : "",
			noticeContent: notiCheck ? resultProcessFour.content : "",
			reviewSettingIdx: resultProcessOne.vcIdx ? resultProcessOne.idx : undefined,
			judgeList: [...resultProcessTwo, ...(check ? resultProcessThree : [])],
		});
	};

	useEffect(() => {
		if (modi) {
			viewDetailRequest.call(tidx, "path");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modi]);

	useEffect(() => {
		switch (viewDetailRequest.state) {
			case API_STATE.done:
				const requestCompanyView = viewDetailRequest.response?.data;

				setTargetRoundIdx(tidx);
				setModiData(requestCompanyView);
				setEvaluateSetupModal(true);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [viewDetailRequest.state, viewDetailRequest.response]);

	useEffect(() => {
		switch (roundFinalSubmitRequest.state) {
			case API_STATE.done:
				setEvaluateSetupModal(false);
				break;
			case API_STATE.error:
				console.log("얼마나 작동 error>> ", roundFinalSubmitRequest.error);
				alert(t("pages.round.RoundManage.RoundManContext.alert01"));
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		roundFinalSubmitRequest.state,
		roundFinalSubmitRequest.response,
		roundFinalSubmitRequest.error,
	]);

	useEffect(() => {
		roundJudgesListRequest.call();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const doSearch = () => {
		viewDetailRequest.call(tidx, "path");
		roundJudgesListRequest.call();
	};

	useEffect(() => {
		switch (roundJudgesListRequest.state) {
			case API_STATE.done:
				const judgeTempList = roundJudgesListRequest.response.data;
				const newData = judgeTempList.map((d, idx) => ({
					userIdx: d.idx,
					role: idx === 0 ? "심사참여" : "",
					img: d.img,
					external: false,
					email: d.id,
					name: d.name,
					id: "",
					pw: "",
				}));
				setJudgeList(newData);
				break;
			case API_STATE.error:
				console.log("얼마나 작동 error>> ", roundJudgesListRequest.error);
				break;
			default:
				break;
		}
	}, [
		roundJudgesListRequest.state,
		roundJudgesListRequest.response,
		roundJudgesListRequest.error,
	]);

	useEffect(() => {
		roundSettingListRequest.singleCall();
	});

	useEffect(() => {
		switch (roundSettingListRequest.state) {
			case API_STATE.done:
				setSettingList(roundSettingListRequest.response.data.list);
				break;
			case API_STATE.error:
				console.log("얼마나 작동 error>> ", roundSettingListRequest.error);
				break;
			default:
				break;
		}
	}, [
		roundSettingListRequest.state,
		roundSettingListRequest.response,
		roundSettingListRequest.error,
	]);

	// 다른 라운드 관리 심사 클릭시 모두 리셋
	useEffect(() => {
		setEvalSetModalStep(0);
		const resetData = judgeList?.map((d, idx) =>
			idx === 0 ? { ...d, role: "심사참여" } : { ...d, role: "" }
		);
		setJudgeList(resetData);
		setCheck(false);
		setModi(false);
		setMoodi("modi");
		setNameSearch();
		if (!evaluateSetupModal) {
			setTargetRoundIdx();
			setResultProcessOne("nope");
			setResultProcessTwo([]);
			setResultProcessThree([]);
			setResultProcessFour({ title: "", content: "" });
			setModiData();
			setNotiCheck(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [evaluateSetupModal]);

	// 다른 라운드 관리 추가 심사 클릭시 모두 리셋
	useEffect(() => {
		setCheck(false);
		setNameSearch();
		const resetData = judgeList?.map((d, idx) =>
			idx === 0 ? { ...d, role: "심사참여" } : { ...d, role: "" }
		);
		setJudgeList(resetData);
		if (!addJudgeModal) {
			setAddEvalTarget();
			setRoundData();
			setAddProSteps(0);
			setNotiCheck(false);
			setresultFromProOne([]);
			setresultFromProTwo("nope");
			setresultFromProThree([]);
			setresultFromProFour([]);
			setresultFromProFive({ title: "", content: "" });
		}
	}, [addJudgeModal]);

	return (
		<AppManContext.Provider
			value={{
				roundList: roundList,
				ref,
				currentTab,
				setCurrentTab,
				loading: pending,
				processStep: EvalSetModalStep,
				setProcessStep: setEvalSetModalStep,
				evaluateSetupModal,
				setEvaluateSetupModal,
				setResultProcessOne,
				resultProcessOne,
				settingList,
				judgeList,
				setJudgeList,
				resultProcessTwo,
				setResultProcessTwo,
				targetRoundIdx,
				check,
				setCheck,
				outSourcing: resultProcessThree,
				setOutSourcing: setResultProcessThree,
				notice: resultProcessFour,
				setNotice: setResultProcessFour,
				notiCheck,
				setNotiCheck,
				finalSubmit,
				setTargetRoundIdx,
				setModi,
				tidx,
				setTidx,
				modiData,
				fin,
				setFin,
				moodi,
				setMoodi,
				addJudgeModal,
				setAddJudgeModal,
				addEvalTarget,
				setAddEvalTarget,
				roundData,
				setRoundData,
				addProSteps,
				setAddProSteps,
				resultFromProOne,
				setresultFromProOne,
				resultFromProTwo,
				setresultFromProTwo,
				resultFromProThree,
				setresultFromProThree,
				additionOutSourcing: resultFromProFour,
				setAdditionOutSourcing: setresultFromProFour,
				resultFromProFive,
				setresultFromProFive,
				finalAdditionSubmit,
				setNameSearch,
				nameSearch,
				doSearch,
				roundListRequest,
				setRoundList,
				formData,
				setFormData,
				totalPage,
			}}
		>
			{children}
			<FinalAlert
				message={t("pages.round.RoundManage.RoundManContext.finalAlert")}
				type="success"
				confirm={t("pages.round.RoundManage.RoundManContext.confirm")}
			/>
		</AppManContext.Provider>
	);
};

export default RoundManContext;
